var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.getters.isMobile && !_vm.$store.getters.isBrowser)?_c('SettingDialog',{attrs:{"show":_vm.showSetting,"settingInfo":_vm.settingInfo},on:{"update:show":function($event){_vm.showSetting=$event}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }